import clientAuth from "../clientAuth";
import client from "../client";
let lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : 'de';

export default {
    store: (userData) => client.post('payment/store', { json: userData }),
    checkCamperAvailability: (userData) => client.post('payment/checkCamperAvailability', { json: userData }),
    checkvoucher: (userData) => client.post('payment/checkvoucher', { json: userData }),
    order_store: (userData) => client.post('orderDetail/store', { json: userData }),
    stripCheckout: (stripedata) => client.post(`payment/stripcheckout?lng=` + lng, { json: stripedata }),
    updatepaymentStatus: (stripedata) => client.post('payment/updatepaymentStatus', { json: stripedata }),
    checkstripepayment: (id) => client.get(`payment/checkstripepayment/${id}`),
    checkStatus: (userData) => client.post('user/tracking-events/status', { json: userData }),
    storeEvent: (userData) => client.post('user/tracking-events/store', { json: userData }),
    index: () => clientAuth.get(`dashboard/index?lng=` + lng),
    tutorials: () => clientAuth.get(`dashboard/tutorials?lng=` + lng),
    cancle: (userData) => clientAuth.post('dashboard/ordercancle', { json: userData }),
    refund: (userData) => clientAuth.post('dashboard/orderrefund', { json: userData }),
    registerconfirm: (order_id, userData) => clientAuth.post(`registration/confirm/payment/${order_id}`, { json: userData }),
};